<div class="eiq-grid-filter-skeleton">
  <div class="eiq-grid-filter-skeleton__side">
    <div class="eiq-grid-filter-skeleton__toggle">
      <div class="eiq-grid-filter-skeleton__toggle-btn"></div>
      <div class="eiq-grid-filter-skeleton__toggle-btn"></div>
      <div class="eiq-grid-filter-skeleton__toggle-btn"></div>
    </div>
  </div>
  <div class="eiq-grid-filter-skeleton__side">
    <div class="eiq-grid-filter-skeleton__search"></div>
    <div class="eiq-grid-filter-skeleton__advanced-btn"></div>
  </div>
</div>
